import * as React from 'react';
import * as styles from './styles.css';
import { Button, ModalWindow, useDeviceType } from '@cian/ui-kit';

import { FiltersModalContent } from '../FiltersModalContent';
import { IPreciseFiltersProps } from '../../types';
import { DEFAULT_SERVER_ERROR } from '../../../../constants/serverError';

export const AllFiltersModal: React.FC<IPreciseFiltersProps> = props => {
  const {
    secondaryPreciseFilters,
    preciseFiltersState,
    onChangePreciseFilterState,
    onModalPrimaryBtnClick,
    onModalSecondaryBtnClick,
    showModalPrimaryBtnLoader,
    showModalPrimaryBtnError,
    isModalOpen,
    onModalClose,
    isDisabledFilters,
    mainBtnCount,
    moreFiltersText,
  } = props;

  const isMobile = useDeviceType() !== 'desktop';

  return (
    <ModalWindow
      title={moreFiltersText}
      onClose={onModalClose}
      fixed
      open={isModalOpen}
      width={640}
      content={
        <FiltersModalContent
          preciseFilters={secondaryPreciseFilters}
          preciseFiltersState={preciseFiltersState}
          handleChange={onChangePreciseFilterState}
          isDisabledFilters={isDisabledFilters}
        />
      }
      footer={
        !isDisabledFilters && (
          <div>
            <div className={styles['footer-buttons']}>
              <div className={styles['footer__btn']}>
                <Button
                  theme="fill_primary"
                  loading={showModalPrimaryBtnLoader}
                  onClick={onModalPrimaryBtnClick}
                  size={isMobile ? 'M' : 'XS'}
                  fullWidth={isMobile}
                  data-testid="precise_filters_refine_estimation"
                >
                  Пересчитать оценку
                </Button>
              </div>
              <div className={styles['footer__btn']}>
                <Button
                  theme={isMobile ? 'fill_secondary' : 'fill_white_primary'}
                  onClick={onModalSecondaryBtnClick}
                  size={isMobile ? 'M' : 'XS'}
                  data-testid="precise_filters_clear_filters"
                  disabled={!mainBtnCount}
                >
                  Сбросить
                </Button>
              </div>
            </div>
            {showModalPrimaryBtnError && (
              <span className={styles['footer_error']} data-testid="precise_filters_error">
                {DEFAULT_SERVER_ERROR}
              </span>
            )}
          </div>
        )
      }
    />
  );
};

AllFiltersModal.displayName = 'AllFiltersModal';
